import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/",
    name: "home",
    component: () => import("../pages/HomePage.vue")
  },
  {
    path: "/auth",
    component: () => import(/* webpackChunkName: "auth" */ "../pages/AuthPage.vue"),
    children: [
      { path: "login", name: "login", component: () => import(/* webpackChunkName: "auth" */ "../pages/Auth/LoginPage.vue") },
      { path: "register", name: "register", component: () => import(/* webpackChunkName: "auth" */ "../pages/Auth/RegistrationPage.vue") },
      { path: "", redirect: "register" }
    ]
  },
  {
    path: "/events",
    component: () => import(/* webpackChunkName: "events" */ "../pages/EventsPage.vue"),
    children: [
      {
        path: "",
        name: "search",
        component: () => import(/* webpackChunkName: "events" */ "../pages/SportEvents/SportEventsPage.vue")
      },
      {
        path: ":id",
        component: () => import(/* webpackChunkName: "events" */ "../pages/SportEvent/SportEventPage.vue"),
        children: [
          {
            path: "leagues/:leagueId",
            name: "leagues",
            component: () => import(/* webpackChunkName: "events" */ "../pages/SportEvent/SportEventLeaguePage.vue"),
            meta: {
              blockScrollToTop: true
            },
            children: [
              {
                path: "rounds/:roundId",
                name: "rounds",
                component: () => import(/* webpackChunkName: "events" */ "../pages/SportEvent/SportEventLeagueRoundPage.vue"),
                meta: {
                  blockScrollToTop: true
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: "/matches/:id",
    component: () => import(/* webpackChunkName: "matches" */ "../pages/MatchPage.vue"),
    children: [
      { path: "", name: "match", component: () => import(/* webpackChunkName: "matches" */ "../pages/Match/MatchDetailsPage.vue") },
      {
        path: "edit",
        name: "edit-match",
        component: () => import(/* webpackChunkName: "matches" */ "../pages/Match/MatchEditPage.vue")
      }
    ]
  },
  {
    path: "/users",
    name: "users",
    component: () => import(/* webpackChunkName: "profile" */ "../pages/Users/UsersPage.vue")
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import(/* webpackChunkName: "profile" */ "../pages/Profile/ProfilePage.vue")
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../pages/AboutPage.vue")
  },
  {
    path: "/my-teams",
    children: [
      {
        path: "",
        name: "myTeams",
        component: () => import(/* webpackChunkName: "teams" */ "../pages/MyTeams/MyTeamsListContainer.vue")
      },
      {
        path: "new",
        component: () => import(/* webpackChunkName: "teams" */ "../pages/MyTeams/MyTeamsNewPage.vue")
      },
      {
        path: ":id",
        component: () => import(/* webpackChunkName: "teams" */ "../pages/MyTeams/MyTeamsEditPage.vue")
      }
    ],
    component: () => import(/* webpackChunkName: "teams" */ "../pages/MyTeamsPage.vue")
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import(/*webpackChunkName: "terms" */ "../pages/TermsPage.vue")
  },
  {
    path: "/statement",
    name: "statement",
    meta: {
      documentTitle: `commitment_statement.title`,
      documentPath: `${process.env.VUE_APP_API_URL}/statement`
    },
    component: () => import(/*webpackChunkName: "statement" */ "../pages/DocumentPage.vue")
  },
  {
    path: "/rules",
    name: "rules",
    meta: {
      documentTitle: `rules.title`,
      documentPath: `${process.env.VUE_APP_API_URL}/rules`
    },
    component: () => import(/*webpackChunkName: "rules" */ "../pages/DocumentPage.vue")
  },
  {
    path: "/privacy",
    name: "privacy",
    meta: {
      documentTitle: `privacy.title`,
      documentPath: `${process.env.VUE_APP_API_URL}/privacy`
    },
    component: () => import(/*webpackChunkName: "privacy" */ "../pages/DocumentPage.vue")
  },
  {
    path: "/documents",
    name: "documents",
    component: () => import(/*webpackChunkName: "documents" */ "../pages/DocumentsPage.vue")
  },
  {
    path: "/accept-invitation/:confirmation_code",
    name: "accept-invitation",
    component: () => import(/*webpackChunkName: "invitation" */ "../pages/AcceptInvitationPage.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (!to.meta["blockScrollToTop"]) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
});

export default router;
